import { create } from 'zustand';
import type { CreditAccount, BoosterPack } from '@/types';
import { creditApi } from '@/api';

interface CreditState {
  totalBalance: number;
  subscriptionBalance: number;
  subscriptionExpiry: string | null;
  boosterPacks: BoosterPack[];
  bonusBalance: number;
  isLoading: boolean;
  fetchAccount: () => Promise<void>;
  updateBalance: (newBalance: number) => void;
  consume: (amount: number) => void;
}

export const useCreditStore = create<CreditState>((set) => ({
  totalBalance: 0,
  subscriptionBalance: 0,
  subscriptionExpiry: null,
  boosterPacks: [],
  bonusBalance: 0,
  isLoading: false,

  fetchAccount: async () => {
    set({ isLoading: true });
    try {
      const account: CreditAccount = await creditApi.getAccount();
      set({
        totalBalance: account.total_balance,
        subscriptionBalance: account.subscription_credits.balance,
        subscriptionExpiry: account.subscription_credits.expires_at,
        boosterPacks: account.booster_packs.sort(
          (a, b) => new Date(a.expires_at).getTime() - new Date(b.expires_at).getTime(),
        ),
        bonusBalance: account.bonus_credits.balance,
        isLoading: false,
      });
    } catch {
      set({ isLoading: false });
    }
  },

  updateBalance: (newBalance) => set({ totalBalance: newBalance }),

  consume: (amount) => set((state) => ({
    totalBalance: Math.max(0, state.totalBalance - amount),
  })),
}));
